<template>
  <base-page
    v-bind:schemaName="'withdrawal'"
    v-bind:isHideRemove="true"
    v-bind:isLoading="isLookupLoading"
    v-model:entity="entity"
  >
    <template v-slot:panel-group="{ entity }">
      <button
        v-if="entity.statusId === '1bf61851-347c-4d0d-a62e-d488dce9c0da'"
        type="submit"
        v-on:click.prevent="confirm(entity)"
        class="btn btn-sm btn-outline-primary"
      >
        Підтвердити виплату
      </button>
      <button
        v-if="entity.statusId === '1bf61851-347c-4d0d-a62e-d488dce9c0da'"
        type="submit"
        v-on:click.prevent="cancel(entity)"
        class="btn btn-sm btn-outline-danger"
      >
        {{ $filters.localize("button.cancel") }}
      </button>
    </template>
    <template v-slot:panel-left="{ entity }">
      <div class="withdrawal-page-compact-side">
        <div class="mb-3 text-left">
          <label class="form-label">Номер заявки</label>
          <input
            disabled
            type="number"
            class="form-control"
            v-model="entity.number"
          />
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Статус</label>
          <select disabled class="form-control" v-model="entity.statusId">
            <option
              v-for="option in statuses"
              v-bind:key="option.id"
              :value="option.id"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Час підтвердження виплати</label>
          <input
            type="datetime-local"
            class="form-control"
            v-model="entity.paidTime"
          />
        </div>
        <div class="mb-3 text-left">
          <label class="form-label">Перевірив</label>
          <label disabled class="form-control">{{
            entity.modifiedBy?.fullName
          }}</label>
        </div>
      </div>
    </template>
    <template v-slot:header="{ entity }">
      <div class="withdrawal-page-compact-header">
        <div class="withdrawal-page-compact-header__grid">
          <div class="withdrawal-page-compact-header__field text-left">
            <label class="form-label">Дроп</label>
            <paginated-select
              v-model="entity.contactId"
              table="contact"
              label-field="fullName"
              class="withdrawal-page-select-no-clear"
              disabled
              :clearable="false"
            />
          </div>
          <div class="withdrawal-page-compact-header__field text-left">
            <label class="form-label">Кількість, грн</label>
            <input
              disabled
              type="number"
              :min="1"
              class="form-control"
              v-model="entity.amount"
            />
          </div>
          <div class="withdrawal-page-compact-header__field text-left">
            <label class="form-label">Отримувач</label>
            <input
              type="text"
              class="form-control"
              v-model="entity.recipient"
            />
          </div>
          <div class="withdrawal-page-compact-header__field text-left">
            <label class="form-label">Реквізити отримувача</label>
            <input
              type="text"
              class="form-control"
              v-model="entity.recipientCard"
            />
          </div>
        </div>
      </div>
    </template>
  </base-page>
</template>

<script>
import BasePage from "@/components/Sections/BasePage.vue";
import PaginatedSelect from "@/components/Selectors/PaginatedSelect.vue";
export default {
  name: "WithdrawalPage",
  components: { BasePage, PaginatedSelect },
  data() {
    return {
      statuses: [],
      entity: {},
      isLookupLoading: false,
    };
  },
  methods: {
    confirm(entity) {
      this.$store
        .dispatch("post", {
          table: "withdrawal",
          method: "confirm",
          body: { Id: entity.id },
        })
        .then((response) => {
          entity.statusId = response.data.data.statusId;
          entity.paidTime = response.data.data.paidTime;
        })
        .catch((error) => this.$toast.error(error.response.data.message));
    },
    cancel(entity) {
      this.$store
        .dispatch("post", {
          table: "withdrawal",
          method: "cancel",
          body: { Id: entity.id },
        })
        .then((response) => {
          entity.statusId = response.data.data.statusId;
        })
        .catch((error) => this.$toast.error(error.response.data.message));
    },

    loadLookups() {
      this.isLookupLoading = true;
      this.$store
        .dispatch("section", { table: "withdrawalStatus" })
        .then((response) => {
          this.statuses = response.data.data;
        })
        .finally(() => {
          this.isLookupLoading = false;
        });
    },
  },
  mounted() {
    this.loadLookups();
  },
};
</script>

<style scoped>
.withdrawal-page-compact-header,
.withdrawal-page-compact-side {
  --withdrawal-control-height: 32px;
  --withdrawal-control-font-size: 13px;
  --withdrawal-control-line-height: 18px;
  --withdrawal-label-height: 14px;
  --withdrawal-label-gap: 3px;
  --withdrawal-field-gap: 12px;
  --withdrawal-field-height: calc(
    var(--withdrawal-label-height) + var(--withdrawal-label-gap) + var(--withdrawal-control-height)
  );

  padding: 4px 6px 0;
}

.withdrawal-page-compact-header__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  grid-auto-rows: var(--withdrawal-field-height);
  gap: var(--withdrawal-field-gap);
  width: 100%;
  align-items: start;
}

.withdrawal-page-compact-header__field {
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--withdrawal-field-height);
}

.withdrawal-page-compact-side>.mb-3 {
  min-height: var(--withdrawal-field-height);
  margin-bottom: var(--withdrawal-field-gap) !important;
}

.withdrawal-page-compact-header .form-label,
.withdrawal-page-compact-side .form-label {
  display: block;
  height: var(--withdrawal-label-height);
  margin-bottom: var(--withdrawal-label-gap);
  color: #526171;
  font-size: 12px;
  font-weight: 700;
  line-height: var(--withdrawal-label-height);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.withdrawal-page-compact-header .form-control,
.withdrawal-page-compact-side .form-control {
  display: block;
  width: 100%;
  min-height: var(--withdrawal-control-height);
  height: var(--withdrawal-control-height);
  max-height: var(--withdrawal-control-height);
  box-sizing: border-box;
  padding: 6px 8px;
  font-size: var(--withdrawal-control-font-size);
  line-height: var(--withdrawal-control-line-height);
}

@media (max-width: 767.98px) {
  .withdrawal-page-compact-header__grid {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
  }

  .withdrawal-page-compact-header__field {
    height: auto;
  }
}
</style>
